const env = process.env.NODE_ENV || 'production';

const config = {
  development: {
    api: {
      baseUrl: 'http://localhost:8080/api',
      //baseUrl: 'https://bachillerdigital.daule.gob.ec/api' ,
      actaPdf: '/acta/pdf',
      actaMayor: '/acta/mayor',
      estudianteFicha: '/estudiante/ficha'
    }
  },
  production: {
    api: {
      baseUrl: 'https://bachillerdigital.daule.gob.ec/api',
      actaPdf: '/acta/pdf',
      actaMayor: '/acta/mayor',
      estudianteFicha: '/estudiante/ficha'
    }
  },
  // You can add more environments like staging if needed
  test: {
    api: {
      baseUrl: 'https://bachillerdigital.daule.gob.ec/api',
      actaPdf: '/acta/pdf',
      actaMayor: '/acta/mayor',
      estudianteFicha: '/estudiante/ficha'
    }
  }
};

// Export the config for the current environment
export default config[env];
